<template>
    <div class="jd-page--expertList">
        <k-row>
            <k-col span="23" class="ta-right">
                <k-button icon="service-o" class="icnBtn" :url="Urls.help"  title="客服与帮助" />
                <k-button icon="bell-o" class="icnBtn" url="/my/messages" title="消息" />
                <k-button icon="setting-o" class="icnBtn" url="/my/setting" title="设置" />
            </k-col>
            <k-col span="1" class="ta-right"></k-col>
        </k-row>

        <div class="mod-info" v-if="appraiserInfo">
            <div class="logo"><img :src="appraiserInfo.logo"  :alt="appraiserInfo.name" /></div>
            <div class="mod-info--bd">
                <div class="title">{{appraiserInfo.name}}</div>
                <div class="desc"><router-link :to="`/detail?aid=${appraiserInfo.aid}`" class="btn-index">个人主页</router-link></div>
            </div>
        </div>

        <!--<k-row type="flex" align="center">
            <k-col span="20">
                <k-notice-bar scrollable left-icon="volume-o" background="transparent">
                    <a href="">通知内容通知内通知内容通知内容通</a>
                    <a href="">通知内容通知内通知内容通知内容通</a>
                    <a href="">通知内容通知内通知内容通知内容通</a>
                </k-notice-bar>
            </k-col>
            <k-col span="4" class="ta-center"><a :href="Urls.help" class="cl-desc fts-sm">更多</a></k-col>
        </k-row>-->
        <k-hr />
        <k-panel title="我的订单" status="状态">
            <template slot="header">
                <div data-v-10213256="" track="" class="k-cell k-panel__header">
                    <div class="k-cell__head">
                        <div class="k-cell__title"><span data-v-10213256="">我的订单</span></div>
                        <div class="k-cell__value k-panel__header-value"><router-link to="/appraiser/order?tab=4" class="cl-desc fts-sm">全部订单 <k-icon name="arrow"></k-icon></router-link></div>
                    </div>
                </div>
            </template>
            <div v-if="appraiserTotal">
                <k-row class="ta-center mod-box--nav">
                    <k-col span="6">
                        <router-link to="/appraiser/order?tab=0" class="link-item">
                            <k-icon name="jian-o" size="0.5rem" :color="iconColor(appraiserTotal.djd)" />
                            <div>待鉴定</div>
                            <span v-if="appraiserTotal.djd >0" class="link-item--num">{{appraiserTotal.djd || 0}}</span>
                        </router-link>
                    </k-col>
                    <k-col span="6">
                        <router-link to="/appraiser/order?tab=1" class="link-item">
                            <k-icon name="todo-list-o" size="0.5rem" :color="iconColor(appraiserTotal.zlxz)" />
                            <div>资料修正</div>
                            <span v-if="appraiserTotal.zlxz >0" class="link-item--num">{{appraiserTotal.zlxz || 0}}</span>
                        </router-link>
                    </k-col>
                    <k-col span="6">
                        <router-link to="/appraiser/order?tab=2" class="link-item">
                            <k-icon name="db-comment-o" size="0.5rem" color="#9B9B9B" />
                            <div>待评价</div>
                        </router-link>
                    </k-col>
                    <k-col span="6">
                        <router-link to="/appraiser/order?tab=3" class="link-item">
                            <k-icon name="passed" size="0.5rem" color="#9B9B9B" />
                            <div>已完成</div>
                        </router-link>
                    </k-col>
                </k-row>
            </div>
        </k-panel>
        <k-hr />
        <k-panel title="我的收入" v-if="appraiserInfo">
            <template slot="header">
                <div class="k-cell k-panel__header">
                    <div class="k-cell__head">
                        <div class="k-cell__title"><span data-v-10213256="">我的收入</span></div>
                        <div class="k-cell__value k-panel__header-value"><router-link to="/appraiser/withdrawlist" class="cl-desc fts-sm">提现明细 <k-icon name="arrow"></k-icon></router-link></div>
                    </div>
                    <div v-if="showWexinBid" class="k-cell__label">{{wxBindInfo}}</div>
                    <div v-if="showAlipayBid" class="k-cell__label">{{alipayBindInfo}}</div>
                </div>
            </template>
            <div>
                <k-row class="mod-box--nav">
                    <k-col span="6">
                        <div class="link-item">
                            <div class="num">{{(appraiserTotal.dsm || 0)|fen2yuan(2)}}</div>
                            <div>待收入<!--(<span v-if="appraiserTotal" class="cl-red">{{appraiserTotal.djd || 0}}笔</span>)--></div>
                        </div>
                    </k-col>
                    <k-col span="6">
                        <div class="link-item">
                            <div class="num">{{(appraiserInfo.takeMoney||0)|fen2yuan(2)}}</div>
                            <div>已提现</div>
                        </div>
                    </k-col>
                    <k-col span="6">
                        <div class="link-item">
                            <div class="num">{{(appraiserInfo.money||0)|fen2yuan(2)}}</div>
                            <div>余额</div>
                        </div>
                    </k-col>
                    <k-col span="6">
                        <div class="link-item">
                            <div class="num">{{(appraiserInfo.totalmoney||0)|fen2yuan(2)}}</div>
                            <div>总收入</div>
                        </div>
                    </k-col>
                </k-row>

            </div>
            <div slot="footer" class="ta-right">
                <k-button type="default" plain round size="small" :url="bindUrl">{{accountInfo && accountInfo.status===2?'查看':'绑定'}}提现账户</k-button>
                <k-button type="default" plain round size="small" :url="CONFIG.takeMoneyDocUrl||''">提现规则</k-button>
            </div>
        </k-panel>
        <k-hr />
        <template v-if="appraiserIndexAdv">
            <div class="mod-body k-panel">
                <k-adv :page-key="appraiserIndexAdv.pageKey" :pos-key="appraiserIndexAdv.posKey"></k-adv>
            </div>
        </template>

        <!--<k-cell-group class="ta-center" v-if="appraiserInfo">
            <h2 class="jd-expert&#45;&#45;title">待鉴定收入  <span class="cl-danger"><small class="cl-danger">&yen;</small>{{(appraiserTotal.dsm || 0)|fen2yuan(2)}}</span></h2>
            <p>您有 <span v-if="appraiserTotal" class="cl-red">{{appraiserTotal.djd || 0}} </span>笔待鉴定订单，总值 &yen;{{(appraiserTotal.dsm || 0)|fen2yuan(2)}} 元！ </p>
            <div>
                <k-button type="danger" plain round to="/appraiser/order">立即鉴定</k-button>
            </div>
            <br />
        </k-cell-group>
        <k-hr />

        <k-cell-group v-if="appraiserInfo">
            <h2 class="ta-center jd-expert&#45;&#45;title">账户余额  <span class="cl-danger"><small class="cl-danger">&yen;</small>{{(appraiserInfo.money||0)|fen2yuan(2)}}</span></h2>
            <k-cell title="您的总收" :value="(appraiserInfo.totalmoney||0)|fen2yuan(2,true)" size="small"></k-cell>
            <k-cell title="提现" :value="(appraiserInfo.takeMoney||0)|fen2yuan(2,true)" size="small"></k-cell>
            <k-cell title="账户余额" :value="(appraiserInfo.money||0)|fen2yuan(2,true)" size="small"></k-cell>
            <k-cell v-if="accountInfo" title="微信绑定账户" :value="accountInfo.realName+':'+accountInfo.mobile" size="small"></k-cell>
            <div class="k-cell ta-center">
                <k-button type="default" plain round size="small" :url="bindUrl">{{!accountInfo?'绑定':'查看'}}提现账户</k-button>
                <k-button type="default" plain round size="small" :url="CONFIG.takeMoneyDocUrl||''">提现规则</k-button>
                <k-button type="default" plain round size="small" to="/appraiser/withdrawlist">提现明细</k-button>
            </div>
        </k-cell-group>
        <k-hr />-->
        <k-cell-group>
            <income-list />
        </k-cell-group>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex"
    import IncomeList from "./mod/income-list"
    export {fen2yuan} from "../../utils/filters"
    import {userMoneyInfo} from "../../api/common"
    export default {
        name: "index",
        data() {
            return {
                accountInfo : null
            }
        },
        computed : {
            ...mapState("config",["CONFIG","Urls","appraiserIndexAdv"]),
            ...mapGetters("jianding", ["appraiserInfo", "userTotal", "appraiserTotal", "getTakeInfo", "getTakeList"]),
            showWexinBid(){
                return this.accountInfo && this.accountInfo.status===2 && this.accountInfo.accountType === 1
            },
            showAlipayBid(){
                return this.accountInfo && this.accountInfo.status===2 && this.accountInfo.accountType === 2
            },
            bindUrl(){
                let backUrl = encodeURIComponent(location.href);
                //return `/account/bank-bind/weixin?backUrl=${backUrl}` //微信
                return `/account/bank-bind/alipay?backUrl=${backUrl}` //支付宝
            },
            wxBindInfo(){
                if(this.accountInfo){
                    return `微信绑定账户（${this.accountInfo.realName}：${this.accountInfo.mobile}）`
                }
                return ''
            },
            alipayBindInfo(){
                if(this.accountInfo && this.accountInfo.aliAccount){
                    return `支付宝绑定账户（${this.accountInfo.realName}：${this.accountInfo.aliAccount}）`
                }
                return ''
            }

        },
        components : {
            IncomeList
        },
        methods:{
            ...mapActions("jianding", ["loadAppraiserInfo", "loadTake"]),
            iconColor(num){
                if(+num > 0){
                    return "#CEA065"
                } else {
                    return "#9B9B9B"
                }
            }
        },
        filters : {
            /*fen2yuan(value, fixed){
                if(!value) return "";
                if(fixed){
                    return (+value/100).toFixed(fixed)
                }
                return Math.round(+value/100)
            }*/
        },
        created() {
            this.loadAppraiserInfo();
            this.loadTake({pageNum:50});
            userMoneyInfo({
                accountType   : 2
            }).then(R => {
                this.accountInfo = R.accountInfo
            })
        },
        watch : {
            appraiserInfo(nv){
                console.log(nv)
            }
        }
    }
</script>

<style scoped>

</style>